<template>
  <div class="goods1">
    <div class="mb20">手动配置一页几个商品</div>
    <el-form :model="currentInfo" label-width="60px">
      <el-form-item label="个数">
        <el-input-number
          v-model="currentInfo.title"
          :min="1"
          :max="100"
        ></el-input-number>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],

  methods: {},
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/goods/goods2/setting.vue